import ComponentWithSocket from '../../../lib/component';
import { Component, Prop } from 'vue-property-decorator';

import { BvModalEvent } from 'bootstrap-vue';

import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import ImageModule from 'docxtemplater-image-module-free';
import { saveAs } from 'file-saver';
import https from 'https';
import Stream from 'stream';
import { saveXlsx, XlsxCellInput, XlsxSheet, XlsxVariant } from '../../../utils/xlsx';
import {
    contractLabel,
    groupSelectedCount,
    isGroupFullySelected,
    lotsLabel,
    safeFileNamePart,
    selectedLotCount,
    setLotsSelected,
    totalLotCount,
    truncate2,
} from '../../../utils/export';

import moment from 'moment';
import 'moment/locale/ro';
moment.locale('ro');

import { PhoneValidation } from '../../../utils/phone-validation';
import { depositorName } from '../../../utils/depositor';

const DELIVERY_STATUS_LABELS: { [status: number]: string } = {
    0: 'Neselectat',
    1: 'În curs de livrare',
    2: 'Livrat',
};

@Component
export default class WinnersTab extends ComponentWithSocket {
    depositorName = depositorName;

    @Prop({ required: true }) auction: any;
    @Prop({ required: true }) auctionId: string;
    @Prop({ required: true }) selectedCurrency: string;

    public data: {
        auctionWinners: any[];
        generatingInvoice: string;
        generatingFactura: string;
        updatingPaymentStatus: string;
        updatingDeliveryStatus: string;
        winnersFilterPayment: '' | 'true' | 'false';
        winnersFilterDelivery: '' | '0' | '1' | '2';
        addCertificateOpen: boolean;
        certificates: any[];
    } = {
        auctionWinners: [],
        generatingInvoice: '',
        generatingFactura: '',
        updatingPaymentStatus: '',
        updatingDeliveryStatus: '',
        winnersFilterPayment: '',
        winnersFilterDelivery: '',
        addCertificateOpen: false,
        certificates: [],
    };

    private paymentStatusRollback: { [winnerId: string]: boolean } = {};
    private paymentStatusSaved: { [winnerId: string]: boolean } = {};
    private deliveryStatusRollback: { [winnerId: string]: number } = {};
    private deliveryStatusSaved: { [winnerId: string]: number } = {};

    public winnerNotes: { [winnerId: string]: any[] } = {};
    public addingNote: { [winnerId: string]: boolean } = {};
    public newNote: { [winnerId: string]: { description: string; termen: string } } = {};

    public addCertificate: {
        salesDate: string;
        releaseDate: string;
        firstName: string;
        lastName: string;
        lotId: string;
    } = {
        salesDate: '',
        releaseDate: '',
        firstName: '',
        lastName: '',
        lotId: '',
    };

    public proformaModal: {
        isOpen: boolean;
        isSubmitting: boolean;
        winner: any;
        client: {
            name: string;
            phone: string;
            email: string;
            county: string;
            city: string;
            address: string;
        };
        products: Array<{
            name: string;
            price: number;
            isService: boolean;
        }>;
        totalRon: number;
        error: string;
        fieldErrors: Array<{ field: string; messages: string[] }>;
    } = {
        isOpen: false,
        isSubmitting: false,
        winner: undefined,
        client: { name: '', phone: '', email: '', county: '', city: '', address: '' },
        products: [],
        totalRon: 0,
        error: '',
        fieldErrors: [],
    };

    public invoiceModal: {
        isOpen: boolean;
        isSubmitting: boolean;
        winner: any;
        seriesName: string;
        issueDate: string;
        dueDate: string;
        error: string;
        fieldErrors: Array<{ field: string; messages: string[] }>;
    } = {
        isOpen: false,
        isSubmitting: false,
        winner: undefined,
        seriesName: 'F-VIKART',
        issueDate: '',
        dueDate: '',
        error: '',
        fieldErrors: [],
    };

    public procesVerbal: {
        isOpen: boolean;
        isGenerating: boolean;
        winner: any;
        error: string;
        form: {
            dateIso: string;
            vikartRepresentative: string;
            primitorCalitate: string;
            primitorName: string;
            primitorAddress: string;
            primitorIdSeries: string;
            primitorIdNumber: string;
            primitorCnp: string;
            hasRepresentative: boolean;
            representativeName: string;
            representativeAddress: string;
            representativeIdSeries: string;
            representativeIdNumber: string;
            representativeCnp: string;
        };
        lots: Array<{
            selected: boolean;
            position: number;
            author_name: string;
            name: string;
            technique: string;
            dimensions: string;
            technicalDetails: string;
            thumbnail: string;
        }>;
    } = {
        isOpen: false,
        isGenerating: false,
        winner: undefined,
        error: '',
        form: {
            dateIso: '',
            vikartRepresentative: 'Luciana V. Stanciu',
            primitorCalitate: 'Cumpărător',
            primitorName: '',
            primitorAddress: '',
            primitorIdSeries: '',
            primitorIdNumber: '',
            primitorCnp: '',
            hasRepresentative: false,
            representativeName: '',
            representativeAddress: '',
            representativeIdSeries: '',
            representativeIdNumber: '',
            representativeCnp: '',
        },
        lots: [],
    };

    public excelExport: {
        isOpen: boolean;
        stale: boolean;
        error: string;
        groups: any[];
    } = {
        isOpen: false,
        stale: false,
        error: '',
        groups: [],
    };

    private parsePaymentConfirmed(value: any): boolean {
        return value === true || value === 'true' || value === 1 || value === '1';
    }

    private parseDeliveryStatus(value: any): number {
        const parsed = parseInt(value, 10);
        if (parsed === 1 || parsed === 2) {
            return parsed;
        }

        return 0;
    }

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.auctions.winners',
            (success: boolean, data: any) => {
                if (success) {
                    let certificates = this.data.certificates;

                    data.forEach((winner: any) => {
                        winner.auctionUser.paymentConfirmed = this.parsePaymentConfirmed(
                            winner.auctionUser.paymentConfirmed,
                        );
                        winner.auctionUser.deliveryStatus = this.parseDeliveryStatus(
                            winner.auctionUser.deliveryStatus,
                        );
                        this.paymentStatusSaved[winner.auctionUser._id] =
                            winner.auctionUser.paymentConfirmed;
                        this.deliveryStatusSaved[winner.auctionUser._id] =
                            winner.auctionUser.deliveryStatus;

                        const wid = winner.auctionUser._id;
                        if (!this.winnerNotes[wid]) this.$set(this.winnerNotes, wid, []);
                        if (!this.newNote[wid]) this.$set(this.newNote, wid, { description: '', termen: '' });
                        if (!this.addingNote[wid]) this.$set(this.addingNote, wid, false);

                        this.loadWinnerNotes(wid);

                        winner.lots.forEach((lot: any) => {
                            if (certificates[lot._id] !== undefined) {
                                lot.certificate = certificates[lot._id].url;
                            }
                        });
                    });

                    this.data.auctionWinners = data;

                    // The export modal works off its own snapshot, so the
                    // selection survives this refresh - just flag it as stale.
                    if (this.excelExport.isOpen) {
                        this.excelExport.stale = true;
                    }
                }
            },
        );

        this.wsListener.onPut(
            'admin.auctions.winners.paymentStatus',
            (success: boolean, data: any) => {
                this.data.updatingPaymentStatus = '';

                if (success) {
                    const winnerId = data && data.winner;
                    if (winnerId) {
                        this.paymentStatusSaved[winnerId] = this.parsePaymentConfirmed(
                            data.paymentConfirmed,
                        );
                        delete this.paymentStatusRollback[winnerId];
                    }
                    return;
                }

                const winnerId = data && data.winner;
                if (winnerId && this.paymentStatusSaved[winnerId] !== undefined) {
                    this.data.auctionWinners = this.data.auctionWinners.map(
                        (winner: any) => {
                            if (String(winner.auctionUser._id) === String(winnerId)) {
                                winner.auctionUser.paymentConfirmed =
                                    this.paymentStatusSaved[winnerId];
                            }
                            return winner;
                        },
                    );
                    delete this.paymentStatusRollback[winnerId];
                }

                alert(
                    (data && data.error) ||
                        'A aparut o eroare la actualizarea statusului incasarii',
                );
            },
        );

        this.wsListener.onPut(
            'admin.auctions.winners.deliveryStatus',
            (success: boolean, data: any) => {
                this.data.updatingDeliveryStatus = '';

                if (success) {
                    const winnerId = data && data.winner;
                    if (winnerId) {
                        this.deliveryStatusSaved[winnerId] = this.parseDeliveryStatus(
                            data.deliveryStatus,
                        );
                        delete this.deliveryStatusRollback[winnerId];
                    }
                    return;
                }

                const winnerId = data && data.winner;
                if (winnerId && this.deliveryStatusSaved[winnerId] !== undefined) {
                    this.data.auctionWinners = this.data.auctionWinners.map(
                        (winner: any) => {
                            if (String(winner.auctionUser._id) === String(winnerId)) {
                                winner.auctionUser.deliveryStatus =
                                    this.deliveryStatusSaved[winnerId];
                            }
                            return winner;
                        },
                    );
                    delete this.deliveryStatusRollback[winnerId];
                }

                alert(
                    (data && data.error) ||
                        'A aparut o eroare la actualizarea statusului livrarii',
                );
            },
        );

        this.wsListener.onGet(
            'admin.auctions.winners.notes',
            (success: boolean, data: any) => {
                if (success && data && data.winner) {
                    this.$set(this.winnerNotes, data.winner, data.notes || []);
                }
            },
        );

        this.wsListener.onPut(
            'admin.auctions.winners.notes',
            (success: boolean, data: any) => {
                if (success && data && data.winner && data.note) {
                    const wid = data.winner;
                    const notes = this.winnerNotes[wid] ? [...this.winnerNotes[wid]] : [];
                    notes.unshift(data.note);
                    this.$set(this.winnerNotes, wid, notes);
                    this.$set(this.newNote, wid, { description: '', termen: '' });
                } else {
                    alert((data && data.error) || 'A aparut o eroare la adaugarea notei');
                }
                if (data && data.winner) {
                    this.$set(this.addingNote, data.winner, false);
                }
            },
        );

        this.wsListener.onDelete(
            'admin.auctions.winners.notes',
            (success: boolean, data: any) => {
                if (success && data && data.winner && data.noteId) {
                    const wid = data.winner;
                    const notes = (this.winnerNotes[wid] || []).filter(
                        (n: any) => String(n._id) !== String(data.noteId),
                    );
                    this.$set(this.winnerNotes, wid, notes);
                } else {
                    alert((data && data.error) || 'A aparut o eroare la stergerea notei');
                }
            },
        );
    }

    mounted() {
        this.wsListener.sendGet('admin.auctions.winners', {
            auction: this.auctionId,
        });

        this.getCertificates();
    }

    beforeDestroy() {
        this.wsListener.destroy();
    }

    public get filteredWinners(): any[] {
        const list = this.data.auctionWinners || [];
        const fp = this.data.winnersFilterPayment;
        const fd = this.data.winnersFilterDelivery;

        if (fp === '' && fd === '') return list;

        return list.filter((w: any) => {
            const au = w.auctionUser || {};
            if (fp !== '') {
                const wantConfirmed = fp === 'true';
                if (this.parsePaymentConfirmed(au.paymentConfirmed) !== wantConfirmed) return false;
            }
            if (fd !== '') {
                if (this.parseDeliveryStatus(au.deliveryStatus) !== parseInt(fd, 10)) return false;
            }
            return true;
        });
    }

    public winnerRowClass(winner: any): string {
        const au = (winner && winner.auctionUser) || {};
        const paid = this.parsePaymentConfirmed(au.paymentConfirmed);
        const delivered = this.parseDeliveryStatus(au.deliveryStatus) === 2;
        if (paid) return 'winner-card-paid';
        if (!paid && !delivered) return 'winner-card-unpaid';
        return '';
    }

    get currencyValue(): string {
        return this.selectedCurrency;
    }

    set currencyValue(val: string) {
        this.$emit('update:selectedCurrency', val);
    }

    get smartbillBaseUrl() {
        return process.env.API2_URL;
    }

    get proformaTotal() {
        // Folosim totalRon (suma neredundanta a loturilor in RON) si aplicam
        // un singur Math.floor la final - aceeasi formula ca la "Pret facturare
        // total" din cardul winnerului. Sumarea preturilor rotunjite produs cu
        // produs pierde uneori 1-2 zecimale prin acumulare.
        return truncate2(this.getTotalPriceAmount(this.proformaModal.totalRon || 0));
    }

    get comissionPercent() {
        return this.auction ? this.auction.comission : 0;
    }

    get currencySymbol() {
        if (this.selectedCurrency == 'EUR') return '€';
        return 'Lei';
    }

    getComissionAmount(amount: number) {
        return amount * (this.comissionPercent / 100);
    }

    getSpecialComissionAmount(amount: number) {
        return (amount * 0.5) / 100;
    }

    getTotalPriceAmount(amount: number) {
        return (
            amount +
            this.getComissionAmount(amount) +
            this.getSpecialComissionAmount(amount)
        );
    }

    formatPrice(amount: number) {
        if (this.selectedCurrency == 'EUR') return amount;
        return amount * this.auction.euroRate;
    }

    proformaViewUrl(winner: any) {
        const series = encodeURIComponent(winner.auctionUser.proformaSeries);
        const number = encodeURIComponent(winner.auctionUser.proformaNumber);
        const token = 'c8f02a40c3fa8e6383228cc95242aac3';
        return `${this.smartbillBaseUrl}/smartbill/proforma`
            + `?token=${token}&seriesName=${series}&number=${number}`;
    }

    invoiceViewUrl(winner: any) {
        const series = encodeURIComponent(winner.auctionUser.invoiceSeries);
        const number = encodeURIComponent(winner.auctionUser.invoiceNumber);
        const token = 'c8f02a40c3fa8e6383228cc95242aac3';
        return `${this.smartbillBaseUrl}/smartbill/invoice`
            + `?token=${token}&seriesName=${series}&number=${number}`;
    }

    doGenerateInvoice(winner: any) {
        if (!winner || !winner.auctionUser || !winner.auctionUser._id) return;
        if (!winner.auctionUser.proformaSeries || !winner.auctionUser.proformaNumber) return;

        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        const today = new Date();
        const due = new Date(today);
        due.setDate(today.getDate() + 11);

        this.invoiceModal.winner = winner;
        this.invoiceModal.seriesName = 'F-VIKART';
        this.invoiceModal.issueDate = fmt(today);
        this.invoiceModal.dueDate = fmt(due);
        this.invoiceModal.error = '';
        this.invoiceModal.fieldErrors = [];
        this.invoiceModal.isSubmitting = false;
        this.invoiceModal.isOpen = true;
    }

    async submitInvoice(bvModalEvt?: BvModalEvent) {
        if (bvModalEvt) bvModalEvt.preventDefault();

        const { winner, seriesName, issueDate, dueDate } = this.invoiceModal;
        if (!winner || !winner.auctionUser || !winner.auctionUser._id) return;

        this.invoiceModal.isSubmitting = true;
        this.invoiceModal.error = '';
        this.invoiceModal.fieldErrors = [];
        this.data.generatingFactura = winner.auctionUser._id;

        const payload = {
            auctionUserId: winner.auctionUser._id,
            seriesName,
            issueDate,
            dueDate,
            isDraft: false,
            useStock: false,
        };

        try {
            const resp = await fetch(`${process.env.API2_URL}/smartbill/invoice?token=c8f02a40c3fa8e6383228cc95242aac3`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const body = await resp.json().catch(() => ({} as any));

            if (!resp.ok || (body && body.success === false)) {
                const fieldErrors: Array<{ field: string; messages: string[] }> = [];
                if (body && body.data && typeof body.data === 'object' && !Array.isArray(body.data)) {
                    Object.keys(body.data).forEach((key) => {
                        const val = body.data[key];
                        const messages = Array.isArray(val) ? val.map((m: any) => String(m)) : [String(val)];
                        fieldErrors.push({ field: key, messages });
                    });
                }
                this.invoiceModal.fieldErrors = fieldErrors;
                this.invoiceModal.error = (body && body.message)
                    ? body.message
                    : `Eroare HTTP ${resp.status}`;
                return;
            }

            this.invoiceModal.isOpen = false;
            this.wsListener.sendGet('admin.auctions.winners', {
                auction: this.auctionId,
            });
        } catch (err) {
            const e: any = err;
            this.invoiceModal.error = e && e.message ? e.message : 'Eroare la generarea facturii';
        } finally {
            this.invoiceModal.isSubmitting = false;
            setTimeout(() => { this.data.generatingFactura = ''; }, 500);
        }
    }

    doInvoiceRegenerate(winner: any) {
        if (!winner || !winner.auctionUser || !winner.auctionUser._id) {
            return;
        }

        const u = winner.user;
        const au = winner.auctionUser;
        const addr = u && u.address ? u.address : undefined;

        this.proformaModal.winner = winner;
        this.proformaModal.client = {
            name: u
                ? `${u.lastName || ''} ${u.firstName || ''}`.trim()
                : `${au.lastName || ''} ${au.firstName || ''}`.trim(),
            phone: (u && PhoneValidation.format(u)) || au.phone || '',
            email: (u && u.email) || au.email || '',
            county: addr ? (addr.county || '') : '',
            city: addr ? (addr.city || '') : '',
            address: addr ? (addr.street || '') : '',
        };

        // Loturile au pretul in EUR (lot.winnerPrice.price). Convertim in RON
        // folosind cursul setat la licitatie (auction.euroRate), apoi calculam
        // comisionul si T.A.P. ca procent din totalul in RON. Aceeasi logica ca
        // in vikart-api/src/lib/helpers/invoice.ts (sendInvoices).
        const euroRate = (this.auction && this.auction.euroRate) || 1;
        const products: Array<{ name: string; price: number; isService: boolean }> = [];

        let totalRon = 0;
        for (const lot of winner.lots) {
            const authorName = lot.author && lot.author.name ? lot.author.name : '';
            const lotRon = lot.soldPrice * euroRate;
            totalRon += lotRon;
            products.push({
                name: `LOT ${lot.position} - ${authorName} - ${lot.name}`,
                price: truncate2(lotRon),
                isService: false,
            });
        }

        // Comisionul si T.A.P. - linii separate (ca in helpers/invoice.ts).
        const commission = truncate2(this.getComissionAmount(totalRon));
        products.push({
            name: `Comision ${this.comissionPercent} %`,
            price: commission,
            isService: false,
        });

        const tap = truncate2(this.getSpecialComissionAmount(totalRon));
        products.push({
            name: 'T.A.P. 0,5 %',
            price: tap,
            isService: false,
        });

        this.proformaModal.products = products;
        this.proformaModal.totalRon = totalRon;
        this.proformaModal.error = '';
        this.proformaModal.fieldErrors = [];
        this.proformaModal.isSubmitting = false;
        this.proformaModal.isOpen = true;
    }

    async submitProforma(bvModalEvt?: BvModalEvent) {
        if (bvModalEvt) bvModalEvt.preventDefault();

        const { client, winner, products } = this.proformaModal;
        if (!winner || !winner.auctionUser || !winner.auctionUser._id) return;

        this.proformaModal.isSubmitting = true;
        this.proformaModal.error = '';
        this.proformaModal.fieldErrors = [];
        this.data.generatingInvoice = winner.auctionUser._id;

        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        const today = new Date();
        const due = new Date(today);
        due.setDate(today.getDate() + 11);

        const payload = {
            auctionUserId: winner.auctionUser._id,
            seriesName: 'VIKART',
            issueDate: fmt(today),
            dueDate: fmt(due),
            currency: 'RON',
            language: 'RO',
            isDraft: false,
            client: {
                name: client.name,
                phone: client.phone,
                email: client.email,
                address: client.address,
                city: client.city,
                county: client.county,
                country: 'Romania',
                isTaxPayer: false,
            },
            products: products.map(p => ({
                name: p.name,
                price: p.price,
                quantity: 1,
                measuringUnitName: 'buc',
                currency: 'RON',
                isTaxIncluded: true,
                isDiscount: false,
                isService: p.isService,
            })),
        };

        try {
            const resp = await fetch(`${process.env.API2_URL}/smartbill/proforma?token=c8f02a40c3fa8e6383228cc95242aac3`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const body = await resp.json().catch(() => ({} as any));

            if (!resp.ok || (body && body.success === false)) {
                const fieldErrors: Array<{ field: string; messages: string[] }> = [];
                if (body && body.data && typeof body.data === 'object') {
                    Object.keys(body.data).forEach((key) => {
                        const val = body.data[key];
                        const messages = Array.isArray(val) ? val.map((m: any) => String(m)) : [String(val)];
                        fieldErrors.push({ field: key, messages });
                    });
                }
                this.proformaModal.fieldErrors = fieldErrors;
                this.proformaModal.error = (body && body.message)
                    ? body.message
                    : `Eroare HTTP ${resp.status}`;
                return;
            }

            this.proformaModal.isOpen = false;
            this.wsListener.sendGet('admin.auctions.winners', {
                auction: this.auctionId,
            });
        } catch (err) {
            const e: any = err;
            this.proformaModal.error = e && e.message ? e.message : 'Eroare la generarea proformei';
        } finally {
            this.proformaModal.isSubmitting = false;
            setTimeout(() => { this.data.generatingInvoice = ''; }, 500);
        }
    }

    updateWinnerPaymentStatus(winner: any, selectedValue: any) {
        if (!winner || !winner.auctionUser || !winner.auctionUser._id) {
            return;
        }

        const winnerId = winner.auctionUser._id;
        const paymentConfirmed = this.parsePaymentConfirmed(selectedValue);

        this.paymentStatusRollback[winnerId] = this.paymentStatusSaved[winnerId];
        winner.auctionUser.paymentConfirmed = paymentConfirmed;
        this.data.updatingPaymentStatus = winnerId;

        this.wsListener.sendPut('admin.auctions.winners.paymentStatus', {
            auction: this.auction._id,
            winner: winnerId,
            paymentConfirmed,
        });
    }

    updateWinnerDeliveryStatus(winner: any, selectedValue: any) {
        if (!winner || !winner.auctionUser || !winner.auctionUser._id) {
            return;
        }

        const winnerId = winner.auctionUser._id;
        const deliveryStatus = this.parseDeliveryStatus(selectedValue);

        this.deliveryStatusRollback[winnerId] = this.deliveryStatusSaved[winnerId];
        winner.auctionUser.deliveryStatus = deliveryStatus;
        this.data.updatingDeliveryStatus = winnerId;

        this.wsListener.sendPut('admin.auctions.winners.deliveryStatus', {
            auction: this.auction._id,
            winner: winnerId,
            deliveryStatus,
        });
    }

    loadWinnerNotes(winnerId: string) {
        this.wsListener.sendGet('admin.auctions.winners.notes', { winner: winnerId });
    }

    addWinnerNote(winnerId: string) {
        const note = this.newNote[winnerId];
        if (!note || !note.description) return;

        this.$set(this.addingNote, winnerId, true);
        const payload: any = {
            winner: winnerId,
            description: note.description,
        };
        if (note.termen) payload.termen = note.termen;

        this.wsListener.sendPut('admin.auctions.winners.notes', payload);
    }

    deleteWinnerNote(winnerId: string, noteId: string) {
        this.wsListener.sendDelete('admin.auctions.winners.notes', {
            winner: winnerId,
            noteId,
        });
    }

    async getCertificates() {
        let that = this;

        await fetch(`${process.env.API2_URL}/certificate?auction=` + this.auctionId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                data.data.forEach((certificate: any) => {
                    that.data.certificates[certificate.lotId] = certificate;
                });
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    addCertificateAction(bvModalEvt: BvModalEvent) {
        bvModalEvt.preventDefault();

        if (!this.addCertificate.firstName || !this.addCertificate.lastName || !this.addCertificate.salesDate || !this.addCertificate.releaseDate) {
            alert('Te rugam sa completezi toate datele din formular');
            return;
        }

        fetch(`${process.env.API2_URL}/certificate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'existing_lot': 1,
                'first_name': this.addCertificate.firstName,
                'last_name': this.addCertificate.lastName,
                'sales_date': this.addCertificate.salesDate,
                'release_date': this.addCertificate.releaseDate,
                'lot_id': this.addCertificate.lotId
            })
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.data.auctionWinners.forEach((winner: any) => {
                    winner.lots.forEach((lot: any) => {
                        if (lot._id === data.data.lotId) {
                            lot.certificate = data.data.url;
                        }
                    });
                });

                this.data.addCertificateOpen = false;
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    updateCertificate(data: any, winner: any) {
        const salesDate = new Date(winner.auctionUser.liveAt);
        const releaseDate = new Date();
        this.data.addCertificateOpen = true;
        this.addCertificate.salesDate = ('0' + salesDate.getDate()).slice(-2) + '-' + ('0' + (salesDate.getMonth() + 1)).slice(-2) + '-' + salesDate.getFullYear();
        this.addCertificate.releaseDate = ('0' + releaseDate.getDate()).slice(-2) + '-' + ('0' + (releaseDate.getMonth() + 1)).slice(-2) + '-' + releaseDate.getFullYear();
        this.addCertificate.firstName = winner.user.firstName;
        this.addCertificate.lastName = winner.user.lastName;
        this.addCertificate.lotId = data.item._id;
    }

    get selectedLotsCount(): number {
        return (this.procesVerbal.lots || []).filter((l: any) => l.selected).length;
    }

    // Unele câmpuri (ex. "Detalii tehnice") sunt salvate ca HTML. docxtemplater
    // le-ar pune ca text brut (s-ar vedea tag-urile <p>...</p>). Extragem doar
    // textul, decodăm entitățile și transformăm break-urile de bloc în spații.
    private stripHtml(value: string): string {
        if (!value) return '';
        let s = String(value)
            .replace(/<\s*br\s*\/?\s*>/gi, ' ')
            .replace(/<\/(p|div|li|tr|h[1-6])\s*>/gi, ' ');
        const tmp = document.createElement('div');
        tmp.innerHTML = s;
        const text = tmp.textContent || (tmp as any).innerText || '';
        return text.replace(/\s+/g, ' ').trim();
    }

    private flattenLotForProcesVerbal(lot: any): any {
        const out: any = {
            selected: true,
            position: lot.position || 0,
            author_name: this.stripHtml((lot.author && lot.author.name) ? lot.author.name : ''),
            name: this.stripHtml(lot.name || ''),
            technique: '',
            dimensions: '',
            technicalDetails: this.stripHtml(lot.technicalDetails || ''),
            thumbnail: '',
        };

        if (Array.isArray(lot.attributes)) {
            for (const attr of lot.attributes) {
                if (!attr || !attr.name) continue;
                switch (attr.name) {
                    case 'Material / Tehnica':
                    case 'Material / Tehnică':
                        out.technique = this.stripHtml(attr.value || '');
                        break;
                    case 'Dimensiuni':
                        out.dimensions = this.stripHtml(attr.value || '');
                        break;
                    case 'Detalii tehnice':
                        if (!out.technicalDetails) out.technicalDetails = this.stripHtml(attr.value || '');
                        break;
                }
            }
        }

        if (Array.isArray(lot.imagesData) && lot.imagesData.length) {
            const first = lot.imagesData[0];
            if (first) out.thumbnail = first.thumbnail || first.full || '';
        }

        return out;
    }

    openProcesVerbal(winner: any) {
        if (!winner || !winner.lots || !winner.lots.length) return;

        const u = this.winnerPerson(winner);
        const firstName = u.firstName || '';
        const lastName = u.lastName || '';
        const fullName = (firstName + ' ' + lastName).trim();

        const today = new Date();
        const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
        const dateIso = today.getFullYear() + '-' + pad(today.getMonth() + 1) + '-' + pad(today.getDate());

        this.procesVerbal.winner = winner;
        this.procesVerbal.error = '';
        this.procesVerbal.isGenerating = false;
        this.procesVerbal.form = {
            dateIso,
            vikartRepresentative: 'Luciana V. Stanciu',
            primitorCalitate: 'Cumpărător',
            primitorName: fullName,
            primitorAddress: '',
            primitorIdSeries: '',
            primitorIdNumber: '',
            primitorCnp: '',
            hasRepresentative: false,
            representativeName: '',
            representativeAddress: '',
            representativeIdSeries: '',
            representativeIdNumber: '',
            representativeCnp: '',
        };
        this.procesVerbal.lots = winner.lots.map((lot: any) => this.flattenLotForProcesVerbal(lot));
        this.procesVerbal.isOpen = true;
    }

    private loadFile(url: string, callback: any) {
        PizZipUtils.getBinaryContent(url, callback);
    }

    private getHttpData(url: string, callback: any) {
        url = url.replace(
            'storage.googleapis.com/vikart-production',
            'vikart-production.storage.googleapis.com',
        );

        // callback este apelat o singură dată; protejăm contra dublei apelări
        // (ex: 'error' pe request + 'error' pe response).
        let done = false;
        const finish = (err: any, data?: any) => {
            if (done) return;
            done = true;
            callback(err, data);
        };

        try {
            const request = https.request(url, function(response) {
                if (response.statusCode !== 200) {
                    return finish(
                        new Error(
                            `Request to ${url} failed, status code: ${response.statusCode}`,
                        ),
                    );
                }

                const data = new Stream.Transform();
                response.on('data', function(chunk) {
                    data.push(chunk);
                });
                response.on('end', function() {
                    finish(undefined, data.read());
                });
                response.on('error', function(e) {
                    finish(e);
                });
            });

            // CRITIC: fără acest handler, o eroare de rețea/CORS (ex. imaginile
            // de pe GCS pe localhost) devine un "Uncaught (in promise)" și
            // oprește întreaga generare. Cu el, sărim peste imagine.
            request.on('error', function(e) {
                finish(e);
            });

            request.end();
        } catch (e) {
            finish(e);
        }
    }

    async doGenerateProcesVerbal(bvModalEvt?: BvModalEvent) {
        if (bvModalEvt) bvModalEvt.preventDefault();

        const form = this.procesVerbal.form;
        const selected = (this.procesVerbal.lots || []).filter((l: any) => l.selected);

        if (!selected.length) {
            this.procesVerbal.error = 'Selectează cel puțin un lot pentru predare.';
            return;
        }
        if (!form.primitorName.trim()) {
            this.procesVerbal.error = 'Numele primitorului este obligatoriu.';
            return;
        }

        this.procesVerbal.error = '';
        this.procesVerbal.isGenerating = true;

        const $this = this;
        this.loadFile('/static/proces_verbal_predare_primire_v1.docx', async function(
            error: any,
            content: any,
        ) {
            if (error) {
                $this.procesVerbal.isGenerating = false;
                $this.procesVerbal.error = 'Nu am putut încărca template-ul: ' + (error.message || error);
                return;
            }

            // 1x1 transparent PNG so loturile fără imagine nu rup randarea
            const TRANSPARENT_PNG_BASE64 =
                'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            const base64ToUint8 = (b64: string) => {
                const bin = atob(b64);
                const len = bin.length;
                const arr = new Uint8Array(len);
                for (let i = 0; i < len; i++) arr[i] = bin.charCodeAt(i);
                return arr;
            };
            const transparentPng = base64ToUint8(TRANSPARENT_PNG_BASE64);

            const opts: any = {
                centered: true,
                fileType: 'docx',
                getImage: function(tagValue: any) {
                    return new Promise(function(resolve, reject) {
                        if (!tagValue) return resolve(transparentPng);
                        $this.getHttpData(tagValue, function(err: any, data: any) {
                            if (err || !data) return resolve(transparentPng);
                            resolve(data);
                        });
                    });
                },
                getSize: function(_img: any, tagValue: any) {
                    if (!tagValue) return [1, 1];
                    return [180, 180];
                },
            };

            const imageModule = new ImageModule(opts);
            const zip = new PizZip(content);
            const doc = new Docxtemplater(zip, { modules: [imageModule] });

            const dateMoment = moment(form.dateIso, 'YYYY-MM-DD');
            const dateToday = dateMoment.isValid()
                ? dateMoment.format('DD.MM.YYYY')
                : moment().format('DD.MM.YYYY');

            const payload: any = {
                date_today: dateToday,
                vikart_representative: form.vikartRepresentative || '',
                primitor_calitate: form.primitorCalitate || '',
                primitor_name: form.primitorName || '',
                primitor_address: form.primitorAddress || '',
                primitor_id_series: form.primitorIdSeries || '',
                primitor_id_number: form.primitorIdNumber || '',
                primitor_cnp: form.primitorCnp || '',
                has_representative: !!form.hasRepresentative,
                representative_name: form.representativeName || '',
                representative_address: form.representativeAddress || '',
                representative_id_series: form.representativeIdSeries || '',
                representative_id_number: form.representativeIdNumber || '',
                representative_cnp: form.representativeCnp || '',
                lots: selected.map((l: any, idx: number) => ({
                    position: l.position || idx + 1,
                    author_name: l.author_name || '',
                    name: l.name || '',
                    technique: l.technique || '',
                    dimensions: l.dimensions || '',
                    technicalDetails: l.technicalDetails || '',
                    thumbnail: l.thumbnail || '',
                })),
            };

            try {
                await doc.resolveData(payload);
                doc.render();
            } catch (e) {
                console.error('Proces-Verbal render error:', e);
                $this.procesVerbal.isGenerating = false;
                const err: any = e;
                $this.procesVerbal.error =
                    'Eroare la generarea documentului: ' + (err && err.message ? err.message : err);
                return;
            }

            const out = doc.getZip().generate({
                type: 'blob',
                mimeType:
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });

            const safeName = safeFileNamePart(form.primitorName, 'primitor');
            const fileName = 'proces-verbal-' + safeName + '-' + dateToday + '.docx';

            saveAs(out, fileName);

            $this.procesVerbal.isGenerating = false;
            $this.procesVerbal.isOpen = false;
        });
    }

    /** Persoana din "Detalii personale": contul din app, altfel datele din sala. */
    private winnerPerson(winner: any): any {
        return winner.user || winner.auctionUser || {};
    }

    private flattenLotForExcel(lot: any): any {
        let depositor = '';
        if (lot.depositor) {
            const name = depositorName(lot.depositor);
            const contract = contractLabel(lot.depositorContract);
            depositor = contract ? `${name}, ctr: ${contract}` : name;
        }

        return {
            selected: false,
            position: lot.position || 0,
            authorName: lot.author && lot.author.name ? String(lot.author.name) : '',
            name: lot.name ? String(lot.name) : '',
            depositor,
            startingEur: Number(lot.startingPrice) || 0,
            adjudecatEur: lot.winnerPrice ? Number(lot.winnerPrice.price) || 0 : 0,
        };
    }

    /**
     * Snapshot of the winners currently shown (page filters applied). Kept
     * separate from `data.auctionWinners`, which is replaced wholesale on every
     * `admin.auctions.winners` response - the selection has to survive that.
     */
    private buildExcelGroups(): any[] {
        return this.filteredWinners
            .filter((winner: any) => winner.lots && winner.lots.length)
            .map((winner: any) => {
                const au = winner.auctionUser;
                const person = this.winnerPerson(winner);
                const name = `${person.lastName || ''} ${person.firstName ||
                    ''}`.trim();

                return {
                    winnerId: String(au._id),
                    paddle: au.paddle,
                    name: name || '(câștigător fără nume)',
                    type: winner.user ? 'Online' : 'Sală',
                    phone: PhoneValidation.format(person),
                    email: person.email ? String(person.email) : '',
                    payment: this.parsePaymentConfirmed(au.paymentConfirmed)
                        ? 'Confirmată'
                        : 'Neconfirmată',
                    delivery:
                        DELIVERY_STATUS_LABELS[
                            this.parseDeliveryStatus(au.deliveryStatus)
                        ],
                    lots: winner.lots.map((lot: any) =>
                        this.flattenLotForExcel(lot),
                    ),
                };
            });
    }

    openExcelExport() {
        this.excelExport.groups = this.buildExcelGroups();
        this.excelExport.error = '';
        this.excelExport.stale = false;
        this.excelExport.isOpen = true;
    }

    get excelExportTotalCount(): number {
        return totalLotCount(this.excelExport.groups);
    }

    get excelExportSelectedCount(): number {
        return selectedLotCount(this.excelExport.groups);
    }

    get excelAllSelected(): boolean {
        const total = this.excelExportTotalCount;
        return total > 0 && this.excelExportSelectedCount === total;
    }

    get excelSomeSelected(): boolean {
        return this.excelExportSelectedCount > 0;
    }

    toggleExcelAll() {
        const next = !this.excelAllSelected;
        (this.excelExport.groups || []).forEach((group: any) =>
            setLotsSelected(group.lots, next),
        );
    }

    excelGroupSelectedCount(group: any): number {
        return groupSelectedCount(group);
    }

    excelGroupAllSelected(group: any): boolean {
        return isGroupFullySelected(group);
    }

    toggleExcelGroup(group: any) {
        setLotsSelected(group && group.lots, !this.excelGroupAllSelected(group));
    }

    doGenerateExcel(bvModalEvt?: BvModalEvent) {
        if (bvModalEvt) bvModalEvt.preventDefault();

        if (this.selectedCurrency !== 'EUR' && !this.auction.euroRate) {
            this.excelExport.error =
                'Licitația nu are curs BNR setat, exportul în Lei ar da valori zero.';
            return;
        }

        this.excelExport.error = '';

        const symbol = this.currencySymbol;
        const money = (eur: number) => truncate2(this.formatPrice(eur));
        const commission = (eur: number) =>
            this.getComissionAmount(eur) + this.getSpecialComissionAmount(eur);
        // Summary rows: every cell styled, amounts as numbers with 2 decimals.
        const summaryRow = (
            variant: XlsxVariant,
            cells: Array<string | number>,
        ): XlsxCellInput[] =>
            cells.map((value: string | number): XlsxCellInput =>
                typeof value === 'number'
                    ? { value, variant, format: 'decimal' }
                    : { value, variant },
            );

        const rows: XlsxCellInput[][] = [];

        rows.push([
            {
                value: `Câștigători — ${(this.auction && this.auction.name) || ''}`,
                variant: 'bold',
            },
        ]);
        rows.push([
            `Monedă: ${symbol}`,
            '',
            `Curs BNR: ${this.auction.euroRate || '-'}`,
            '',
            `Comision: ${this.comissionPercent}% + T.A.P. 0,5%`,
            '',
            `Generat: ${moment().format('DD.MM.YYYY HH:mm')}`,
        ]);
        rows.push([]);
        rows.push([
            { value: 'Paletă', variant: 'header' },
            { value: 'Câștigător', variant: 'header' },
            { value: 'Tip', variant: 'header' },
            { value: 'Telefon', variant: 'header' },
            { value: 'Email', variant: 'header' },
            { value: 'Lot', variant: 'header' },
            { value: 'Denumire', variant: 'header' },
            { value: 'Deponent', variant: 'header' },
            { value: `Preț început (${symbol})`, variant: 'header' },
            { value: `Preț adjudecare (${symbol})`, variant: 'header' },
            { value: `Comision (${symbol})`, variant: 'header' },
            { value: `Preț facturare (${symbol})`, variant: 'header' },
            { value: 'Status încasare', variant: 'header' },
            { value: 'Status livrare', variant: 'header' },
        ]);

        // Accumulated in integer cents so TOTAL GENERAL adds up to the printed
        // subtotals exactly.
        let grandAdjudecatCents = 0;
        let grandCommissionCents = 0;
        let grandTotalCents = 0;
        let winnerCount = 0;
        let lotCount = 0;

        (this.excelExport.groups || []).forEach((group: any) => {
            const selected = (group.lots || []).filter((lot: any) => lot.selected);
            if (!selected.length) return;

            let totalEur = 0;

            selected.forEach((lot: any) => {
                totalEur += lot.adjudecatEur;

                rows.push([
                    group.paddle,
                    group.name,
                    group.type,
                    group.phone,
                    group.email,
                    lot.position,
                    lot.authorName ? `${lot.authorName} - ${lot.name}` : lot.name,
                    lot.depositor || '-',
                    { value: money(lot.startingEur), format: 'decimal' },
                    { value: money(lot.adjudecatEur), format: 'decimal' },
                    { value: money(commission(lot.adjudecatEur)), format: 'decimal' },
                    {
                        value: money(this.getTotalPriceAmount(lot.adjudecatEur)),
                        format: 'decimal',
                    },
                    group.payment,
                    group.delivery,
                ]);
            });

            // Same formulas as the winner's "Financiar" card: computed once on
            // the total, not summed from the truncated per-lot values.
            const adjudecat = money(totalEur);
            const commissionTotal = money(commission(totalEur));
            const invoiceTotal = money(this.getTotalPriceAmount(totalEur));

            rows.push(
                summaryRow('bold', [
                    `Subtotal ${group.name}`,
                    '',
                    '',
                    '',
                    '',
                    '',
                    lotsLabel(selected.length),
                    '',
                    '',
                    adjudecat,
                    commissionTotal,
                    invoiceTotal,
                    group.payment,
                    group.delivery,
                ]),
            );
            rows.push([]);

            grandAdjudecatCents += Math.round(adjudecat * 100);
            grandCommissionCents += Math.round(commissionTotal * 100);
            grandTotalCents += Math.round(invoiceTotal * 100);
            winnerCount++;
            lotCount += selected.length;
        });

        const winnersLabel =
            winnerCount === 1 ? '1 câștigător' : `${winnerCount} câștigători`;

        rows.push(
            summaryRow('total', [
                'TOTAL GENERAL',
                '',
                '',
                '',
                '',
                '',
                `${winnersLabel}, ${lotsLabel(lotCount)}`,
                '',
                '',
                grandAdjudecatCents / 100,
                grandCommissionCents / 100,
                grandTotalCents / 100,
                '',
                '',
            ]),
        );

        const sheet: XlsxSheet = {
            name: 'Castigatori',
            rows,
            freezeRows: 4,
            columns: [
                { width: 8 },
                { width: 28 },
                { width: 9 },
                { width: 15 },
                { width: 30 },
                { width: 7 },
                { width: 55 },
                { width: 35 },
                { width: 16 },
                { width: 20 },
                { width: 16 },
                { width: 20 },
                { width: 16 },
                { width: 18 },
            ],
        };

        const safeName = safeFileNamePart(
            this.auction && this.auction.name,
            'licitatie',
        );

        saveXlsx(
            [sheet],
            'castigatori-' + safeName + '-' + moment().format('DD.MM.YYYY') + '.xlsx',
        );

        this.excelExport.isOpen = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/auction-manage/winners-tab/index.ts